export const PURCHASE_OUTSTANDING_REPORT_REQUEST = 'PURCHASE_OUTSTANDING_REPORT_REQUEST';
export const PURCHASE_OUTSTANDING_REPORT_SUCCESS = 'PURCHASE_OUTSTANDING_REPORT_SUCCESS';
export const PURCHASE_OUTSTANDING_REPORT_FAILURE = 'PURCHASE_OUTSTANDING_REPORT_FAILURE';